/**
 * Base dialog controller
 *
 * @type {ngController}
 */
export class tmrDialogController {
  static ngType = 'controller'

  constructor($mdDialog, $transitions) {
    'ngInject'
    Object.assign(this, { $mdDialog, $transitions })
  }

  $onInit() {
    this.onBeforeTransitionCancel = this.$transitions.onBefore({}, () =>
      this.onBeforeTransition()
    )
  }

  onBeforeTransition() {
    this.onBeforeTransitionCancel()
    this.close()
  }

  close() {
    return this.$mdDialog.hide()
  }
}
